import * as React from "react";
import Switch from "../../../hiberUiKit/src/atoms/Switch/Switch";
import Bill from "../../../model/bill/Bill";
import Toast from "../../helper/Toast";
import {notifyBugsnagAndShowToast} from "../../../utils/Utils";
import {OnFailure, OnSuccess} from "../../../store/action/actionHelpers";
import {connect, Dispatch} from "react-redux";
import {updatePayViaMobileFlag} from "../../../store/action/bill/bill";
import "../billDetails.scss";

interface ComponentProps {
	/**
	 * Bill data.
	 */
	bill: Bill;
}

interface DispatchProps {
	/**
	 * Change bill in mobile visibility.
	 * @param {string} billId
	 * @param {boolean} payViaMobile
	 * @param {OnSuccess} onSuccess
	 * @param {OnFailure} onFailure
	 */
	updatePayViaMobileFlag: (billId: string, payViaMobile: boolean, onSuccess: OnSuccess, onFailure: OnFailure) => void;
}

type Props = ComponentProps & DispatchProps;

/**
 * Show bill in mobile switch.
 */
class ShowBillInMobileSwitch extends React.PureComponent <Props, {}> {
	render() {
		const onChange = (value: boolean) => this.onChangeShowBillInMobile(value, this.props.bill.id);
		return (
			<div className="c-bill-details_pay-via-mobile-switch">
				<Switch label={"Show bill in mobile app"} checked={this.props.bill.payViaMobile} onChange={onChange}/>
			</div>
		);
	}

	onChangeShowBillInMobile = (value: boolean, billId: string) => {
		let successToastBody: string;
		if (value) {
			successToastBody = "Bill will be shown in mobile";
		}
		else {
			successToastBody = "Bill will not be shown in mobile";
		}
		this.props.updatePayViaMobileFlag(billId, value, () => Toast.success(successToastBody, "Bill update"), this.onFailure)
	};

	onFailure = (error: any) => notifyBugsnagAndShowToast(error, "Bill update");
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		updatePayViaMobileFlag: (billId: string, payViaMobile: boolean, onSuccess: OnSuccess, onFailure: OnFailure) => dispatch(
			updatePayViaMobileFlag(billId, payViaMobile, onSuccess, onFailure)
		)
	}
}

export default connect(null, mapDispatchToProps)(ShowBillInMobileSwitch)
